import script from "./floatingDeleteCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./floatingDeleteCell.vue?vue&type=script&setup=true&lang=ts"

import "./floatingDeleteCell.vue?vue&type=style&index=0&id=03aafe3a&lang=scss"

const __exports__ = script;

export default __exports__